import React from 'react';
import { Link } from 'react-router-dom';
import useNewsSectionPrefetch from '../hooks/useNewsSectionPrefetch';

const NewsSectionLink = ({
  section,
  limit = 25,
  children,
  ...linkProps
}) => {
  const prefetch = useNewsSectionPrefetch(section, limit);

  return (
    <Link
      {...linkProps}
      onFocus={prefetch}
      onMouseEnter={prefetch}
      onTouchStart={prefetch}
    >
      {children}
    </Link>
  );
};

export default NewsSectionLink;
